import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHDepartamentoGet = async (credentials, data) => {
    const body = {
        service: "RNHDepartamentoGet",
        params: {
            rnhDepartamentoId: data?.id || null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
